export default __webpack_public_path__ + "static/media/logo-converge.b3b890d3.svg";